if (!customElements.get('product-card-swatches')) {
  class ProductCardSwatches extends HTMLElement {
    connectedCallback() {
      this.activeSwatch = null;

      this.addEventListener('mouseover', this.onHover.bind(this));
      this.addEventListener('mouseleave', this.onLeave.bind(this));
      this.addEventListener('focusin', this.onHover.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    getSwatch(event) {
      return event.target.closest('[data-variant-image]');
    }

    // Query the image fresh each time (rather than caching once) so this keeps
    // working even if the theme swaps/re-renders the media element later.
    getMediaImage() {
      const img = this.closest('.card-wrapper')?.querySelector('.card__media img');
      if (img && this.defaultSrc === undefined) {
        this.defaultSrc = img.getAttribute('src');
        this.defaultSrcset = img.getAttribute('srcset');
        this.defaultAlt = img.getAttribute('alt');
      }
      return img;
    }

    onHover(event) {
      const swatch = this.getSwatch(event);
      this.mediaImage = this.getMediaImage();
      if (!swatch || !this.mediaImage) return;
      this.applyImage(swatch);
    }

    onLeave() {
      if (this.activeSwatch) return;
      this.mediaImage = this.getMediaImage();
      this.resetImage();
    }

    onFocusOut(event) {
      if (!this.contains(event.relatedTarget)) {
        if (this.activeSwatch) return;
        this.mediaImage = this.getMediaImage();
        this.resetImage();
      }
    }

    onClick(event) {
      const swatch = this.getSwatch(event);
      if (!swatch) return;
      // Swatches are preview-only: never navigate, never let the click
      // bubble up to the card's title/image link.
      event.preventDefault();
      event.stopPropagation();
      this.mediaImage = this.getMediaImage();
      this.setActive(swatch);
    }

    onKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      const swatch = this.getSwatch(event);
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      this.mediaImage = this.getMediaImage();
      this.setActive(swatch);
    }

    setActive(swatch) {
      if (this.activeSwatch === swatch) {
        this.activeSwatch.classList.remove('card_swatch--active');
        this.activeSwatch = null;
        this.resetImage();
        return;
      }
      if (this.activeSwatch) {
        this.activeSwatch.classList.remove('card_swatch--active');
      }
      this.activeSwatch = swatch;
      swatch.classList.add('card_swatch--active');
      this.applyImage(swatch);
    }

    applyImage(swatch) {
      const newSrc = swatch.getAttribute('data-variant-image');
      const newSrcset = swatch.getAttribute('data-variant-image-srcset');
      if (!newSrc || !this.mediaImage) return;
      this.mediaImage.setAttribute('src', newSrc);
      if (newSrcset) {
        this.mediaImage.setAttribute('srcset', newSrcset);
      } else {
        this.mediaImage.removeAttribute('srcset');
      }
      const label = swatch.getAttribute('aria-label');
      if (label) this.mediaImage.setAttribute('alt', label);
    }

    resetImage() {
      if (!this.mediaImage) return;
      this.mediaImage.setAttribute('src', this.defaultSrc);
      if (this.defaultSrcset) {
        this.mediaImage.setAttribute('srcset', this.defaultSrcset);
      } else {
        this.mediaImage.removeAttribute('srcset');
      }
      this.mediaImage.setAttribute('alt', this.defaultAlt);
    }
  }
  customElements.define('product-card-swatches', ProductCardSwatches);
}